import React from "react";
import { useHistory } from "react-router-dom";
import icon1 from "../../../assets/social-security-icons/social-security-vs-fra.svg";
import icon2 from "../../../assets/social-security-icons/social-security-vs-70.svg";
import icon3 from "../../../assets/social-security-icons/spouse-ss-vs-fra.svg";
import icon4 from "../../../assets/social-security-icons/compare-age.svg";
import icon5 from "../../../assets/social-security-icons/tabler_link.svg";
import "../styles/socialSecurity.css";

export const SocialSecurityModules = () => {
  const history = useHistory();

  const modules = [
    {
      id: 1,
      name: "I would like to take Social Security early vs starting at Full Retirement Age",
      link: "/planner/social-security/fra",
      icon: icon1,
    },
    {
      id: 2,
      name: "I would like to take Social Security early vs starting at age 70",
      link: "/planner/social-security/early-vs-70",
      icon: icon2,
    },
    {
      id: 3,
      name: "I would like to take spousal Social Security early vs starting at Full Retirement Age",
      link: "/planner/social-security/spousal-early-vs-FRA",
      icon: icon3,
    },
    {
      id: 4,
      name: "I would like to compare the break-even points for any two ages",
      link: "/planner/social-security/compare-ages",
      icon: icon4,
    },
  ];
  const otherLinks = [
    {
      id: 1,
      name: "There is an early retirement reduction and information that can be found here:",
      link: "https://www.ssa.gov/oact/quickcalc/early_late.html",
      icon: icon5,
    },
    {
      id: 2,
      name: "The most important advice is to access the Social Security website and get their most current official guidance on how to apply:",
      link: "https://www.ssa.gov/retirement",
      icon: icon5,
    },
  ];

  return (
    <div className="social-other-modules">
      {" "}
      <div className="social-security-main-heading">
        Select the module you would like to explore:
      </div>
      <div className="social-security-modules-tag-container">
        {modules &&
          modules.map((item, index) => (
            <div key={index} className="social-security-main-module-container">
              <div className="social-security-result-icon-container">
                <img
                  width={36}
                  height={36}
                  src={item.icon}
                  alt={item.name}
                ></img>
              </div>
              <div className="social-security-modules-name-main">
                <div className="social-result-modules-name-heading">
                  {" "}
                  {item.name}{" "}
                </div>
                <div
                  className="social-security-calculator-module-button"
                  onClick={() => {
                    history.push(item.link);
                  }}
                >
                  Click Here
                </div>
              </div>
            </div>
          ))}
      </div>
      <div
        className="social-security-main-heading"
        style={{ marginTop: "1rem" }}
      >
        Reference Links:
      </div>
      <div className="social-security-modules-tag-container">
        {otherLinks &&
          otherLinks.map((item, index) => (
            <div key={index} className="social-security-main-module-container">
              <div className="social-security-result-icon-container">
                <img
                  width={36}
                  height={36}
                  src={item.icon}
                  alt={item.name}
                ></img>
              </div>
              <div className="social-security-modules-name-main">
                <div className="social-result-modules-name-heading">
                  {" "}
                  {item.name}{" "}
                </div>
                <div
                  className="social-security-calculator-module-button"
                  onClick={() => {
                    window.open(item.link, "_blank");
                  }}
                >
                  Click Here
                </div>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};
